import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../../utils';
import { Plus } from 'lucide-react';

export default function PunishmentHeader() {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Data Punishment</h1>
        <p className="text-gray-500 mt-1">Kelola hukuman disiplin pegawai</p>
      </div>
      <Link to={createPageUrl('PunishmentForm')}>
        <button className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md font-medium flex items-center">
          <Plus className="w-4 h-4 mr-2" /> Tambah Punishment
        </button>
      </Link>
    </div>
  );
}
